import {
  CustomFieldAttribute,
  CustomFieldAttributeValue,
  CustomFieldSelectAttribute,
  CustomFieldSelectAttributeOption,
  CustomFieldStringListAttributeValue,
} from 'apis/customFields';

/**
 * Parses custom field attribute value to ensure it's correctly composed, e.g.
 * sometimes backend would return some string set values in an incorrect order
 * which need to be sorted to work properly on frontend.
 *
 * @param attribute The attribute schema.
 * @param value The attribute value.
 */
export function parseCustomFieldAttributeValue(
  attribute: CustomFieldAttribute,
  value?: CustomFieldAttributeValue,
): CustomFieldAttributeValue | undefined {
  if (!value) return value;

  switch (attribute.type) {
    case 'select':
      return getSortedHierarchicalValue(
        attribute,
        value as CustomFieldStringListAttributeValue,
      );
    default:
      return value;
  }
}

/**
 * Sorts string set value by hierarchy as defined by the attribute options.
 *
 * @param attribute The select attribute schema.
 * @param value The string set attribute value.
 */
function getSortedHierarchicalValue(
  attribute: CustomFieldSelectAttribute,
  value: CustomFieldStringListAttributeValue,
): CustomFieldStringListAttributeValue {
  const sortedValue: string[] = [];

  const walkOptions = (
    options: readonly CustomFieldSelectAttributeOption[],
  ) => {
    const foundOption = options.find((option) =>
      value.value.includes(option.value),
    );

    if (foundOption) {
      sortedValue.push(foundOption.value);

      if (foundOption.options) {
        walkOptions(foundOption.options);
      }
    }
  };

  walkOptions(attribute.options);

  return {
    ...value,
    value: sortedValue,
  };
}
